export const UserActionTypes = {
  SET_CURRENT_USER: "SET_CURRENT_USER",
  SET_USER_NAME: "SET_USER_NAME",
  SET_USER_PERMS: "SET_USER_PERMS",
};
